<template>
    <div></div>
</template>

<script>
export default {
    mounted: function() {

        this.$store.dispatch('handleNextResult')

        this.$router.push({
            name: 'master-result'
        })
    }
}
</script>
